// IMPORTS
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import PublicIcon from '@mui/icons-material/Public';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";

// STYLES
const styles = {
  details: {
    padding: "1rem",
    borderTop: "1px solid #e1e1e1",
        
  },
  value: {
    padding: "1rem 2rem",
    borderTop: "1px solid #e1e1e1",
    color: "#899499"
  }
};

//APP
export default function ProfileDetails() {
  return (
    <Card variant="outlined">
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        {/* CARD HEADER START */}
        <Grid item sx={{ p: "1.5rem 0rem", textAlign: "center" }}>
          {/* PROFILE PHOTO */}
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={
              <CheckCircleOutlineRoundedIcon
                sx={{
                  border: "5px solid white",
                  backgroundColor: "#fff",
                  color: "#429bf5",
                  borderRadius: "50%",
                  padding: ".1rem",
                  width: 35,
                  height: 35
                }}
              ></CheckCircleOutlineRoundedIcon>
            }
          >
            <Avatar
              sx={{ width: 100, height: 100, mb: 1.5 }}
              src="/photos/profile.jpg"
            ></Avatar>
          </Badge>

          {/* DESCRIPTION */}
          <Typography variant="h6">CodeByVinit</Typography>
          <Typography color="text.secondary">codebyvinit.in</Typography>
        </Grid>
        {/* CARD HEADER END */}

        {/* DETAILS */}
        <Grid container>
          <Grid item xs={12}  alignItems="center">
          <Typography style={styles.details}   component="div"
          sx={{
            display: "flex",
            flexDirection: "row", // Stack icons vertically
            alignItems: "center", // Center icons horizontally
            justifyContent: "center", // Center icons vertically (if needed)
            gap: 2, // Space between icons
            padding: 2,
          
          }}>   <InstagramIcon
                sx={{
                  backgroundColor: "#fff",
                  color: "#ea0304",
                  width: 35,
                  height: 35
                }}
              ></InstagramIcon> 
              <PublicIcon
              sx={{
                backgroundColor: "#fff",
                color: "blue",
                width: 35,
                height: 35
              }}
            ></PublicIcon>
             <TwitterIcon
              sx={{
                backgroundColor: "#fff",
                color: "blue",
                width: 35,
                height: 35
              }}
            ></TwitterIcon> <FacebookIcon
            sx={{
              backgroundColor: "#fff",
              color: "blue",
              width: 35,
              height: 35
            }}
          ></FacebookIcon></Typography>
          
          </Grid>
      
        </Grid>

        {/* BUTTON */}
        <Grid item style={styles.details} sx={{ width: "100%" }}>
          <Button
            variant="contained"
            color="error"
            sx={{ width: "99%", p: 1, my: 2, gap: 2, }}
            onClick={() => window.open("https://www.youtube.com/@CodeByVinit/featured", "_blank")}
          >
            View on YouYube   <YouTubeIcon></YouTubeIcon>
          </Button>

        </Grid>
      </Grid>
    </Card>
  );
}
